import cn from 'classnames';
import { bool, func, string } from 'prop-types';

import styles from './styles.module.scss';

function Checkbox({
  containerClassName,
  placeholder: label,
  name,
  disabled,
  value,
  labelClassName,
  checkboxClassName,
  onChange,
  defaultChecked,
  register,
  ...checkboxProps
}) {
  const registerParams = register ? register(name, checkboxProps) : undefined;
  return (
    <div className={cn(styles.container, containerClassName)}>
      <label className={cn(styles.checkboxLabel, checkboxClassName)}>
        <input
          type="checkbox"
          disabled={disabled}
          checked={value}
          onChange={onChange}
          defaultChecked={defaultChecked}
          {...checkboxProps}
          {...registerParams}
        />
        <span className={styles.checkboxCustom} />
      </label>
      <span className={cn(styles.label, labelClassName)}>{label}</span>
    </div>
  );
}

Checkbox.propTypes = {
  checkboxClassName: string,
  containerClassName: string,
  defaultChecked: bool,
  disabled: bool,
  labelClassName: string,
  name: string,
  placeholder: string,
  register: func,
  value: bool,
  onChange: func
};

export default Checkbox;
